import React from "react";

import { IgButton, IgTooltip } from "@intelligems/ig-theme";
import { Dialog } from "@mui/material";
import { ProductPicker } from "@src/components/MainApp/SharedProductPicker/ProductPicker";
import { useDispatch, useSelector } from "@src/store";
import {
  closeProductPicker,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { isProductPickerOpen } from "@src/store/slices/productPicker/selectors/isProductPickerOpen";
import { isValidProductPickerSelection } from "@src/store/slices/productPicker/selectors/isValidProductPickerSelection";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

// Product picker for analytics filter drawer
interface AnalyticsSelectedProductPickerDialogProps {
  onSelectedAnalyticsProductsChange: (
    products: ProductPickerSelectedProduct[]
  ) => void;
  selectedAnalyticsProductCount: number;
  onUpdateDialogFilter: () => void;
}

export const AnalyticsSelectedProductPickerDialog = ({
  onSelectedAnalyticsProductsChange,
  selectedAnalyticsProductCount,
  onUpdateDialogFilter,
}: AnalyticsSelectedProductPickerDialogProps) => {
  const validProductPickerSelection = useSelector(
    isValidProductPickerSelection
  );
  const productPickerOpen = useSelector(
    isProductPickerOpen("selectedAnalyticsProducts")
  );

  const selectedProducts = useSelector(getProductPickerSelectedProducts);
  const dispatch = useDispatch();

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      open={productPickerOpen}
      sx={{ zIndex: 1401 }}
      onClose={() => {
        if (selectedAnalyticsProductCount === 0) {
          onUpdateDialogFilter();
        }
        dispatch(closeProductPicker());
      }}
      slotProps={{
        paper: {
          style: { borderRadius: 15 },
        },
      }}
    >
      <ProductPicker
        dialogActions={[
          <IgButton
            key={`button-2`}
            color={"secondary"}
            onClick={() => {
              if (selectedAnalyticsProductCount === 0) {
                onUpdateDialogFilter();
              }
              dispatch(closeProductPicker());
            }}
          >
            Cancel
          </IgButton>,
          <IgTooltip
            key={"button-1-tooltip"}
            title={
              selectedProducts.length > 250
                ? "Analytics can not be filtered to more than 250 products using this filter"
                : ""
            }
          >
            <IgButton
              key={`button-1`}
              onClick={() => {
                onSelectedAnalyticsProductsChange(selectedProducts);
                dispatch(closeProductPicker());
              }}
              disabled={
                !validProductPickerSelection || selectedProducts.length > 250
              }
            >
              Add Products
            </IgButton>
          </IgTooltip>,
        ]}
      />
    </Dialog>
  );
};
